(function () {
  function initCartTrigger(button) {
    var selector = button.dataset.cartSelector;

    button.addEventListener('click', function () {
      if (selector) {
        var realCartIcon = document.querySelector(selector);
        if (realCartIcon) {
          realCartIcon.click();
          return;
        }
        console.warn(
          '[Iconos flotantes] No se encontró ningún elemento con el selector "' +
            selector +
            '". Revisa el selector en la configuración de la sección.'
        );
      }

      // Fallback: if no selector was set or nothing matched, just go to the cart page.
      var sectionEl = button.closest('.floating-icons');
      var settings = (window.floatingIconsSettings || {})[sectionEl ? sectionEl.id.replace('floating-icons-', '') : ''];
      window.location.href = (settings && settings.cartFallbackUrl) || '/cart';
    });
  }

  function updateCartCount(badge) {
    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!badge) return;
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      })
      .catch(function () {
        /* silently ignore - badge just won't update */
      });
  }

  function init() {
    document.querySelectorAll('[id^="floating-cart-trigger-"]').forEach(function (button) {
      initCartTrigger(button);

      var badge = button.querySelector('[data-floating-cart-count]');
      if (badge) {
        updateCartCount(badge);

        // Many themes dispatch one of these after add-to-cart / cart changes.
        // We listen for the common ones so the badge stays in sync without
        // needing to know the theme's exact internals.
        ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (eventName) {
          document.addEventListener(eventName, function () {
            updateCartCount(badge);
          });
        });

        // Fallback: also refresh right after any click on an "add to cart" form.
        document.addEventListener('submit', function (event) {
          if (event.target && event.target.action && event.target.action.indexOf('/cart/add') !== -1) {
            setTimeout(function () {
              updateCartCount(badge);
            }, 700);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
